export async function sendLogoutToFlutter(chatId?: string, data?: string) {
  let messageToFlutter;
  if (chatId) {
    messageToFlutter = {
      removeDevice: true,
      streamKey: import.meta.env.VITE_GETSTREAMIO_APIKEY,
      streamUser: chatId,
      streamToken: data,
    };
  } else {
    messageToFlutter = {
      removeDevice: false,
    };
  }
  const message = JSON.stringify(messageToFlutter);
  if (window.Logout) {
    window.Logout.postMessage(message);
  }
  if (window.flutter_inappwebview) {
    window.flutter_inappwebview.callHandler('Logout', message);
  }
}
